import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../auth/services/auth.service';
import { ROUTES } from '../constants/routes.constants';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  router.navigate([ROUTES.AUTH.LOGIN], { queryParams: { returnUrl: state.url } });
  return false;
};
